<template>
    <div class="border bg-gray-100 rounded faq-item cursor-move p-4 mt-3">
        <div class="mb-4">Latest Articles</div>

        <Select
            label="Type"
            name="type_id"
            v-model="form.type_id"
            class="mt-2 col-span-3"
            :options="[
                { value: 1, name: 'Blog' },
                { value: 2, name: 'Guide' },
            ]"
            @input="() => {
                // can't use watch because it will be triggered when setForm is called by mounted, then tag will be null on load
                form.tag = null;
            }"
            :error="errorBag?.type_id ? errorBag.type_id[0] : null"
        />

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">Tag</p>
            <reference
                link-text="Link existing tags"
                :linkable="true"
                :creatable="false"
                :language="language"
                v-model="form.tag"
                field-name="tag"
                model-data="Tag"
                v-tooltip="{ content: 'Leave blank to select all tags', container: false, placement: 'top-start', html: false, }"
                :should-open-new-window="true"
                :query="{
                    type_id: form.type_id
                }"
            />
        </div>

        <input-text
            label="Limit"
            name="limit"
            class="mt-3"
            type="number"
            :min="0"
            v-model="form.limit"
            v-tooltip="{ content: 'Leave blank to set unlimited', container: false, placement: 'top-start', html: false, }"
            :error="errorBag?.limit ? errorBag.limit[0] : null"
        />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../../config/siteLanguage'
export default {
    components: { draggable },
    name: "LatestArticles",
    props: {
        value: {
            type: Object,
            required: true,
        },
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data(){
        return {
            form: {
                type_id: null,
                tag: null,
                tag_id: null,
                limit: null,
            },
        }
    },
    mounted: function () {
        this.setForm();
    },
    methods: {
        setForm() {
            if (this.value && this.value.type_id) {
                this.form.type_id = this.value.type_id;
                this.form.tag = this.value.tag ?? null;
                this.form.tag_id = this.value.tag_id ?? this.value.tag?.id ?? null;
                this.form.limit = this.value.limit ?? null;
            }
        }
    },
    watch: {
        "form.tag": function (newValue) {
            this.form.tag_id = newValue ? newValue.id : null;
        },
        value: {
            deep: true,
            handler: function (newValue) {
                this.setForm();
            },
        },
        form: {
            deep: true,
            handler: function (newValue) {
                this.$emit('input', newValue);
            },
        },
    },
};
</script>
